import { Button, Tooltip } from '@material-ui/core';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { UserAvatar } from 'src/components/UserAvatar';

import { useStyles } from './useStyles';

export const ProfileButton = ({ onClick, name, email, planLabel }) => {
  const styles = useStyles();

  return (
    <Tooltip
      disableFocusListener
      title={
        <div className={styles.tooltipContent}>
          <CustomTypography variant={TYPOGRAPHY_VARIANT.bold12}>{name}</CustomTypography>
          <CustomTypography variant={TYPOGRAPHY_VARIANT.regular12}>{email}</CustomTypography>
          {planLabel && (
            <CustomTypography variant={TYPOGRAPHY_VARIANT.regular12}>
              Current plan: {planLabel}
            </CustomTypography>
          )}
        </div>
      }
    >
      {/*
        HINT: we want to allow the user to log out or change customer while the native
              "SubscriptionPausedWall" is displayed, therefore "z-index: 41" is used to display
              ProfileButton on top of that wall's overlay ("z-index: 40", pinned inline in
              src/views/SubscriptionPausedWall/SubscriptionPausedWall.tsx).
      */}
      <Button
        className={styles.button}
        onClick={onClick}
        data-testid="profileButton"
        data-onboarding="ProfileButton"
      >
        <UserAvatar
          name={name}
          className={styles.avatar}
        />
      </Button>
    </Tooltip>
  );
};
